var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"ml-3",staticStyle:{"color":"white"},attrs:{"color":"#4989d1","dark":!_vm.disabled,"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.save($event)}}},[_vm._v(" 途中保存 ")])}
var staticRenderFns = []

export { render, staticRenderFns }